<script setup lang="ts">
defineProps<{
  pdf: string
  alt?: string
  width?: number
  height?: number
  thumbClass?: string
  placeholderClass?: string
}>()

const thumbGenerated = ref(false)
</script>

<template>
  <div class="ics-7mcaa6">
    <PdfThumbGen
      v-bind="$props"
      :class="thumbClass"
      @ready="thumbGenerated = true"
    />
    <div
      v-if="!thumbGenerated"
      class="ics-o63hh5"
      :class="placeholderClass"
    >
      <div class="i-carbon-document-pdf bg-white/90 size-48" />
      <picture>
        <source
          srcset="/ics-matte.webp"
          type="image/webp"
        >
        <img
          src="/ics-matte.jpg"
          alt="This image of the Rocky Mountains serves as a background until the document cover is rendered."
          class="absolute-inset object-cover size-full -z-1"
        >
      </picture>
    </div>
  </div>
</template>
